var _excluded = ["children", "legend", "hideLegend", "renderLegendAsLabel", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { Component } from 'react';
import { string, bool, node } from 'prop-types';
import classNames from 'classnames';
import './Fieldset.scss';
var propTypes = {
  children: node.isRequired,

  /** The legend of the fieldset. Serves as a title for all the children in the fieldset. */
  legend: string.isRequired,

  /** Show the legend with the visual style of a label */
  renderLegendAsLabel: bool,

  /** Visually hide the legend */
  hideLegend: bool,

  /** Add your own custom class names to the component */
  className: string
};
/** Used to semantically group several components inside a form. */

var Fieldset = function Fieldset(_ref) {
  var children = _ref.children,
      legend = _ref.legend,
      hideLegend = _ref.hideLegend,
      renderLegendAsLabel = _ref.renderLegendAsLabel,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  var componentClassNames = classNames('rds-fieldset', className);
  var legendClassNames = classNames('rds-legend', {
    'rds-legend--render-as-label': renderLegendAsLabel,
    'rds-is-vishidden': hideLegend
  });
  return /*#__PURE__*/React.createElement("fieldset", _extends({
    className: componentClassNames
  }, rest), /*#__PURE__*/React.createElement("legend", {
    className: legendClassNames
  }, legend), children);
};

Fieldset.propTypes = propTypes;
export default Fieldset;